import React, { CSSProperties, FC } from 'react'

interface LineProps {
  className?: string
  orientation?: 'vertical' | 'horizontal'
  position?: 'start' | 'end'
  style?: CSSProperties
}

export const Line: FC<LineProps> = ({
  className,
  orientation = 'vertical',
  position = 'start',
  style,
}) => {
  const isVertical = orientation === 'vertical'

  const verticalPath =
    'M0.375957 694.983C-0.253373 580.009 0.323522 464.926 0.264527 349.897C0.35631 234.868 -0.45002 119.729 0.375987 4.81071C0.434987 -1.35351 1.5691 -1.84885 1.64121 4.81071C2.17221 62.27 1.96243 119.839 1.94276 177.354C1.72642 292.383 1.70675 407.411 1.90341 522.44C1.92963 579.954 2.00174 637.469 1.64118 694.983C1.62151 697.9 1.32651 700.157 0.979069 699.991C0.651291 699.826 0.395623 697.625 0.382512 694.983L0.375957 694.983Z'
  const horizontalPath =
    'M5.01692 0.375948C119.99 -0.25339 235.074 0.323507 350.103 0.264509C465.132 0.35629 580.269 -0.45005 695.187 0.375961C701.352 0.434962 701.851 1.56909 695.187 1.6412C637.731 2.1722 580.16 1.96242 522.646 1.94275C407.617 1.72642 292.589 1.70675 177.56 1.90341C120.046 1.92963 62.5314 2.00175 5.01692 1.64118C2.09996 1.62152 -0.156639 1.32651 0.00851868 0.979065C0.173609 0.651284 2.37513 0.395614 5.01692 0.382503V0.375948Z'

  return (
    <svg
      className={className}
      fill={'none'}
      height={isVertical ? '100%' : '2'} // 100% for vertical, height for horizontal
      style={{ justifySelf: position, ...style }}
      width={isVertical ? '2' : '100%'} // Width for vertical, 100% for horizontal
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path d={isVertical ? verticalPath : horizontalPath} fill={'#181716'} />
    </svg>
  )
}
